import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Gallery from './pages/Gallery';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Awards from './pages/Awards';
import NutmegUses from './pages/NutmegUses';
import Brands from './pages/Brands';
import PlantingTips from './pages/PlantingTips';
import Inquiry from './pages/Inquiry';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App bg-cream min-h-screen">
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/uses-of-nutmeg" element={<NutmegUses />} />
            <Route path="/brands" element={<Brands />} />
            <Route path="/planting-tips" element={<PlantingTips />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/inquiry" element={<Inquiry />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
